import React from "react"
import styled from "styled-components"


const MapResponsive = styled.div`
    margin: 80px 0;
    overflow:hidden;
    padding-bottom:56.25%;
    position:relative;
    height: 0;
    iframe{
    left:0;
    top:0;
    height:100%;
    width:100%;
    position:absolute;
        }
`
const CardWrapper = styled.div`
.contact-info{
  display: flex;
  width: 100%;
  max-width: 1200px;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}
.card{
  padding: 0 20px;
  margin: 0 10px;
  width: calc(50% - 20px);
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.card-icon{
  background: #2364ce;
  text-align: center;
  transition: 0.3s linear;
}
.card p{
  font-family: ${props => props.theme.fonts.mont};
  margin-top: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  max-height: 0;
  font-size: 2rem;
  transition: 0.3s linear;
}
@media screen and (max-width:800px) {
  .contact-info{
    flex-direction: column;
  }
  .card{
    width: 100%;
    max-width: 300px;
    margin: 10px 0;
  }
}

`

const Form = styled.form`
  width: 100%;
  height: 100%;
  max-width: 1000px;
  padding: 0 60px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-top: 3rem;
  font-family: ${props => props.theme.fonts.mont};
  @media (max-width: 900px) {
    padding: 0 40px;
  }
  @media screen and (max-width: ${props => props.theme.sizes.mobile}) {
    padding: 0 20px;
    select,
    textarea,
    input {
      font-size: 16px !important;
    }
  }
  input,
  textarea {
    background: white;
    font-size: inherit;
    border: none;
    outline: none;
    padding: 1em;
    &::-webkit-input-placeholder {
      color: black;
      text-transform: uppercase;
    }
    &::-moz-placeholder {
      color: black;
      text-transform: uppercase;
    }
    &:-ms-input-placeholder {
      color: black;
      text-transform: uppercase;
    }
    &:-moz-placeholder {
      color: black;
      text-transform: uppercase;
    }
    &:required {
      box-shadow: none;
    }
    &:focus {
      outline: none;
    }
  }
  &::before {
    content: "";
    background: black;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    transition: 0.2s all;
    opacity: ${props => (props.overlay ? ".8" : "0")};
    visibility: ${props => (props.overlay ? "visible" : "hidden")};
  }
  h2 {
    margin-bottom: 40px;
  }
`

const Message = styled.textarea.attrs(() => ({
  "data-hj-whitelist": "",
}))`
  width: 100%;
  line-height: 1.6;
  resize: vertical;
  min-height: 150px;
`

const Input = styled.input`
  font-family: ${props => props.theme.fonts.mont};
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 0;
`
const InputWrapper = styled.div`
  padding: 0.2rem;
  border: 0.1rem solid ${props => props.theme.colors.black};
  margin-bottom: 2rem;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`
const InputGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  ${InputWrapper} {
    width: 49%;
  }
`
const SubmitButton = styled.button`
  border: 0.1rem solid #000 !important;
  color: #000;
  height: 6rem;
  width: 210px;
  max-width: 100%;
  opacity: ${props => (props.buttonDisabled ? 0.5 : 1)} !important;
  pointer-events: ${props =>
    props.buttonDisabled ? "none" : "all"} !important;
`

export default class MyForm extends React.Component {
  constructor(props) {
    super(props)
    this.submitForm = this.submitForm.bind(this)
    this.state = {
      status: "",
    }
  }

  render() {
    const { status } = this.state
    return (
      <Form
        onSubmit={this.submitForm}
        action="https://formspree.io/mwkwkvvv"
        method="POST"
      >
        <h2>İLETİŞİM BİLGİLERİ</h2>
        <CardWrapper>
          <div className="contact-info">
            <div className="card">
              <p className="card-header">E-Mail</p>
              <p>ayazsan@gmail.com</p>
            </div>
            <div className="card">
              <p className="card-header">Telefon</p>
              <p>+90 (541) 631 70 13</p>
            </div>
          </div>
        </CardWrapper>
        <MapResponsive>
          <iframe title="Ayazsan Haritalar" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6294.391059657509!2d32.48440735379229!3d37.925862317814946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d08fde612ce047%3A0x3e256a2150c5a147!2sAyazsan%20Gayrimenkul!5e0!3m2!1str!2str!4v1600614471604!5m2!1str!2str" width="600" height="250" frameborder="0" style={{ border: 0 }} allowfullscreen="" aria-hidden="false" ></iframe>
        </MapResponsive>
        <h2>TEKLİF FORMU</h2>
        <InputGroup>
          <InputWrapper>
            <Input
              name="firstname"
              type="text"
              placeholder="Adınız *"
              required
            />
          </InputWrapper>
          <InputWrapper>
            <Input
              name="lastname"
              type="text"
              placeholder="Soyadınız *"
              required
            />
          </InputWrapper>
        </InputGroup>
        <InputGroup>
          <InputWrapper>
            <Input name="email" type="email" placeholder="Email *" required />
          </InputWrapper>
          <InputWrapper>
            <Input name="phone" type="tel" placeholder="Telefon" />
          </InputWrapper>
        </InputGroup>
        <InputWrapper>
          <Input name="subject" type="subject" placeholder="Konu *" required />
        </InputWrapper>
        <InputWrapper>
          <Message
            name="message"
            type="text"
            placeholder="Mesajınız *"
            required
          />
        </InputWrapper>

        {status === "SUCCESS" ? (
          <p>
            İletişime geçtiğiniz için teşekkür ederiz. En kısa zamanda size geri
            dönüş yapacağız.
          </p>
        ) : (
            <SubmitButton>GÖNDER</SubmitButton>
          )}
        {status === "ERROR" && (
          <p>
            Hay aksi! Sanırım bir şeyler yanlış veya eksik. Geçerli bir e-mail
            adresi girdiğinizden emin olun.
          </p>
        )}
      </Form>
    )
  }

  submitForm(ev) {
    ev.preventDefault()
    const form = ev.target
    const data = new FormData(form)
    const xhr = new XMLHttpRequest()
    xhr.open(form.method, form.action)
    xhr.setRequestHeader("Accept", "application/json")
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return
      if (xhr.status === 200) {
        form.reset()
        this.setState({ status: "SUCCESS" })
      } else {
        this.setState({ status: "ERROR" })
      }
    }
    xhr.send(data)
  }
}